/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from "react";
import { Typography, makeStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import CheckboxComponent from "app/common/CheckboxComponent";
import { useSelector, useDispatch } from "react-redux";
import {
  addScenarioTotals,
  setSelectedScenario,
} from "app/scenarios/duck/slices";
import athenaClient from "lib/axios/clients";
import { REACT_APP_BASE_URL } from "resources/constants";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
  circularProgress: {
    color: "white",
  },
  scenarioInfoRow: {
    display: "flex",
    alignItems: "center",
    "& :first-child": {
      marginRight: "10px",
    },
  },
  scenarioTitle: {
    marginBottom: "5px",
  },
  dialogTitle: {
    borderBottom: "1px solid #e2e2e2",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
  },
  dialogActions: {
    borderTop: "1px solid #e2e2e2",
  },
  checkboxContainer: {
    flex: 1,
  },
}));

const withStarredScenario = (
  WrappedComponent,
  scenarioTotal,
  visibleScenarios
) => {
  return (props) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();

    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const scenariosSlice = useSelector((state) => state.scenarios);
    const user = useSelector((state) => state.auth.user);

    const createStarredScenario = async () => {
      const config = {
        method: "PUT",
        url: `${REACT_APP_BASE_URL}/scenarios/${scenarioTotal.scenario.id}`,
        data: {
          id: scenarioTotal.scenario.id,
          is_starred: true,
        },
      };
      await athenaClient(config);

      const starredScenario = {
        ...scenarioTotal,
        scenario: {
          ...scenarioTotal.scenario,
          is_starred: true,
        },
      };

      dispatch(
        addScenarioTotals({ [starredScenario.scenario.id]: starredScenario })
      );

      if (
        scenariosSlice.selectedScenario.scenario_id ===
        starredScenario.scenario_id
      ) {
        dispatch(setSelectedScenario(starredScenario));
      }
    };

    const controlStarredScenario = async () => {
      const previousStarred = visibleScenarios.find((elm) => {
        return elm.scenario.is_starred === true;
      });

      if (previousStarred) {
        const config = {
          method: "PUT",
          url: `${REACT_APP_BASE_URL}/scenarios/${previousStarred.scenario_id}`,
          data: {
            id: previousStarred.scenario_id,
            is_starred: false,
          },
        };

        await athenaClient(config);

        const prevStarredScenario = {
          ...previousStarred,
          scenario: {
            ...previousStarred.scenario,
            is_starred: false,
          },
        };

        dispatch(
          addScenarioTotals({
            [prevStarredScenario.scenario.id]: prevStarredScenario,
          })
        );

        if (
          scenariosSlice.selectedScenario.scenario_id ===
          prevStarredScenario.scenario_id
        ) {
          dispatch(setSelectedScenario(prevStarredScenario));
        }
      }
    };

    const handleClickDialogOpen = async (e) => {
      e.stopPropagation();
      const isStarredScenarioCycleIgnoredByUser = cookies.get(
        "starredScenarioByUserSelected"
      )?.[
        `${user.username}-${scenariosSlice.selectedScenario.scenario.cycle.id}`
      ];
      if (isStarredScenarioCycleIgnoredByUser) {
        await controlStarredScenario();
        createStarredScenario();
      } else setDialogOpen(true);
    };

    const handleDialogClose = (e) => {
      e.stopPropagation();
      setDialogOpen(false);
      if (props.onDialogClose) props.onDialogClose(e);
    };

    const onConfirmAction = async (e, confirm) => {
      e.stopPropagation();
      if (checkboxChecked) {
        cookies.set(
          "starredScenarioByUserSelected",
          JSON.stringify({
            ...cookies.get("starredScenarioByUserSelected"),
            [`${user.username}-${scenariosSlice.selectedScenario.scenario.cycle.id}`]: true,
          }),
          { path: "/" }
        );
      }
      if (confirm) {
        await controlStarredScenario();
        createStarredScenario();
      }
      setDialogOpen(false);
      setCheckboxChecked(false);
    };

    const handleDialogClick = (e) => {
      /**
       * We need to stop the propagation of the click event when clicking
       * anywhere within the dialog window to prevent side effects
       */
      e.stopPropagation();
    };

    return (
      <>
        <WrappedComponent
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          onClick={handleClickDialogOpen}
          onMouseDown={handleClickDialogOpen}
        />
        <Dialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onClick={handleDialogClick}
        >
          <DialogTitle className={classes.dialogTitle}>
            Warning: Star Scenario
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              This scenario will be also starred for all your teammates. Do you
              want to procced?
            </Typography>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Box className={classes.checkboxContainer}>
              <CheckboxComponent
                label="Don’t ask me again for this cycle"
                labelPlacement="start"
                checkboxOnchange={(e) => setCheckboxChecked(e.target.checked)}
                checkboxName="dialogCheckbox"
                checkboxSize="medium"
                checkboxColor="primary"
              />
            </Box>
            <Button autoFocus onClick={handleDialogClose}>
              Cancel
            </Button>
            <Button onClick={(e) => onConfirmAction(e, true)} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };
};

export default withStarredScenario;
